import { SpintrTypes } from "src/typings";

export function dateToDaysOfWeekEnum(date: Date): SpintrTypes.DaysOfWeek {
    switch (date.getDay()) {
        case 0: return SpintrTypes.DaysOfWeek.Sunday;
        case 1: return SpintrTypes.DaysOfWeek.Monday;
        case 2: return SpintrTypes.DaysOfWeek.Tuesday;
        case 3: return SpintrTypes.DaysOfWeek.Wednesday;
        case 4: return SpintrTypes.DaysOfWeek.Thursday;
        case 5: return SpintrTypes.DaysOfWeek.Friday;
        case 6: return SpintrTypes.DaysOfWeek.Saturday;

        default: throw new Error("Invalid day of week");
    }
}

/**
 * Accepts a date and a a DaysOfWeek bitmask, and returns true if the date
 * falls on one of the days specified in the bitmask.
 *
 * @param date - The date to check
 * @param daysOfWeek - The bitmask representing the days of the week
 * @return {boolean} True if the date falls on one of the specified days,
 * otherwise false
 */
export function isDateInDaysOfWeek(
    date: Date,
    daysOfWeek: SpintrTypes.DaysOfWeek,
): boolean {
    const dayOfWeek = dateToDaysOfWeekEnum(date);

    return (daysOfWeek & dayOfWeek) === dayOfWeek;
}

